require.config({
	baseUrl: '/jslib',
	waitSeconds: 60,
	paths: {
		'underscore.amd': 'mypages/underscore.amd',
		'jquery.amd': 'mypages/jquery.amd',
		'backbone': '../jsthirdparty/backbone-1.1.2',
		'isMobile': '../jsthirdparty/isMobile-0.4.1.min',
		'react': '../jsthirdparty/react',
		'react-dom': '../jsthirdparty/react-dom',
		'striptags': '../jsthirdparty/striptags_min-2.1.2',
		'timepicker': '../jsthirdparty/bootstrap-timepicker.min',
		'he': '../jsthirdparty/he',
		'iscroll': '../jsthirdparty/iscroll-probe',
		'intlTelInput': '../jsthirdparty/intlTelInput.min'
	},
	map: {
		'*': {
			'underscore': 'underscore.amd',
			'jquery': 'jquery.amd'
		}
	}
});
